import { TIER_BY_KEY } from "@/lib/game";

const ORDER = ["big_win", "little_win", "little_loss", "big_loss"];

// Renders "1× BW · 2× LW · 1× LL · 1× BL" with each tier tinted green (wins) or red (losses).
export default function BreakdownLabel({ breakdown, className = "" }) {
  if (!breakdown) return null;
  const parts = ORDER.filter((k) => breakdown[k]);
  if (!parts.length) return null;
  return (
    <span className={`font-mono ${className}`} data-testid="breakdown-label">
      {parts.map((k, i) => {
        const t = TIER_BY_KEY[k];
        return (
          <span key={k}>
            {i > 0 && <span className="text-slate-600"> · </span>}
            <span style={{ color: t.text }}>{breakdown[k]}× {t.code}</span>
          </span>
        );
      })}
    </span>
  );
}
